import { render, staticRenderFns } from "./FileDisplayCard.vue?vue&type=template&id=63262e29&scoped=true&"
import script from "./FileDisplayCard.vue?vue&type=script&lang=js&"
export * from "./FileDisplayCard.vue?vue&type=script&lang=js&"
import style0 from "./FileDisplayCard.vue?vue&type=style&index=0&id=63262e29&scoped=true&lang=css&"
import style1 from "./FileDisplayCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63262e29",
  null
  
)

export default component.exports